import React from "react";
import { Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";

import { makeStyles, createStyles } from "@material-ui/styles";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
const useCategoryCardStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      height: "100%",
      transition: ".30s all",
      "&:hover": {
        border: `1px solid transparent`,
        boxShadow: `0px 8px 16px 0px rgb(0 0 0 / 15%)`,
      },
    },
    heading: {
      marginTop: theme.spacing(2),
    },
    link: {
      textDecoration: "none",
      color: "inherit",
    },
    icon: {
      margin: `0 auto`,
      width: 80,
      height: 80,
    },
  })
);

const CategoryCard: React.FC<CategoryCardProps> = (props) => {
  const {
    category_name,
    page_slug,
    category_image,
    course_count,
    course_learners,
  } = props;
  const classes = useCategoryCardStyle();
  const { country } = useRouter().query;
  return (
    <Link
      href={
        country ? `/${country}/courses/${page_slug}` : `/courses/${page_slug}`
      }
      className={classes.link}
    >
      <Paper variant="outlined" className={classes.root}>
        <Avatar className={classes.icon}>
          {category_image ? (
            <Image
              src={
                process.env.NEXT_PUBLIC_ADMIN_URL +
                "storage/images/" +
                category_image
              }
              width={80}
              height={80}
              alt="course-icon"
            />
          ) : (
            <span>Icon</span>
          )}
        </Avatar>

        <Typography variant="h4" align="center" className={classes.heading}>
          {category_name}
        </Typography>
        <Box
          paddingTop={[1, 2, 2, 3]}
          display="flex"
          justifyContent="space-evenly"
        >
          <Typography variant="caption">{course_count} Courses</Typography>
          <Divider style={{ width: 1, height: "unset" }} />
          <Typography variant="caption">{course_learners} Learners</Typography>
        </Box>
      </Paper>
    </Link>
  );
};

export default CategoryCard;
